module.exports = __webpack_public_path__ + "static/media/img-23f99a50.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo/ascension-logo.png
// module id = 5275
// module chunks = 39